import { render, staticRenderFns } from "./RestrictionsPage.vue?vue&type=template&id=aa1d076a&scoped=true"
import script from "./RestrictionsPage.vue?vue&type=script&lang=ts"
export * from "./RestrictionsPage.vue?vue&type=script&lang=ts"
import style0 from "./RestrictionsPage.vue?vue&type=style&index=0&id=aa1d076a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1d076a",
  null
  
)

export default component.exports